import { lazy, Suspense } from "react";
import { useAppSelector } from "@/redux/hooks";
import { eventosSelectors } from "@/redux/slices/eventos.slice";

const CredencialFontsSync = lazy(() => import("./CredencialFontsSync"));

/**
 * Rodada 3: substitui o <FontLoader> que envolvia o app inteiro. O useGoogleFonts (catalogo
 * grande de fontes) so baixa quando ha credenciais na store, nunca nas paginas publicas.
 */
export function CredencialFontsGate() {
  const credenciais = useAppSelector(eventosSelectors.CredenciaisEventoSelector);
  if (!credenciais || credenciais.length === 0) return null;
  return (
    <Suspense fallback={null}>
      <CredencialFontsSync />
    </Suspense>
  );
}
